module.exports = __webpack_public_path__ + "static/strokeweight-140-380b69998072568086be2fde421814d1.woff2";